import {BlindsValues, TemperatureValues} from '@lib/store';
import {TFunction} from 'i18next';

export const getTemperatureOptionTitle = (value: TemperatureValues, t: TFunction) => {
  switch (value) {
    case 2:
      return t('controls:Maximum');
    case 1:
      return t('controls:High');
    case 0:
      return t('controls:Normal');
    case -1:
      return t('controls:Low');
    case -2:
      return t('controls:Minimum');
  }
};

export const getTemperatureToastMessage = (value: TemperatureValues, t: TFunction) => {
  switch (value) {
    case 2:
      return t('controls:TemperatureSetMaximum');
    case 1:
      return t('controls:TemperatureSetHigh');
    case 0:
      return t('controls:TemperatureSetNormal');
    case -1:
      return t('controls:TemperatureSetLow');
    case -2:
      return t('controls:TemperatureSetMinimum');
  }
};

export const getBlindsOptionTitle = (value: BlindsValues, t: TFunction) => {
  switch (value) {
    case 0:
      return t('controls:Up');
    case 25:
      return '75%';
    case 50:
      return '50%';
    case 75:
      return '25%';
    case 100:
      return t('controls:Down');
  }
};

export const getBlindsToastMessage = (value: BlindsValues, t: TFunction) => {
  switch (value) {
    case 0:
      return t('controls:BlindsSetMaximum');
    case 25:
      return t('controls:BlindsSetHigh');
    case 50:
      return t('controls:BlindsSetNormal');
    case 75:
      return t('controls:BlindsSetLow');
    case 100:
      return t('controls:BlindsSetMinimum');
  }
};
